<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'text'">
        <input nbInput type="text" class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name" [value]="field.value">
        <button nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})">Submit</button>
    </ng-container>
    <ng-container *ngSwitchCase="'header'">
        <textarea nbInput class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name" [value]="field.value"></textarea>
        <button nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})">Submit</button>
    </ng-container>
    <ng-container *ngSwitchCase="'contentElement'">
        <kve-content-element-field-editor  [field]="field"></kve-content-element-field-editor>
        <textarea nbInput class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name" [value]="field.value"></textarea>
        <button nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})">Submit</button>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <input nbInput type="text" class="input-field" #valueField fullWidth fieldSize="tiny" [name]="field.name">
        <button nbButton size="tiny" fullWidth status="primary"type="submit" (click)="onSubmitInput({name:field.name,value:valueField.value})">Submit</button>
    </ng-container>
</ng-container>


